import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import default CSS for Toastify
import './CustomToastStyles.css'; // Import custom styles
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import './Loader.css';
//import { BASE_URL } from "./Constants.js";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const Loader = () => (
    <div className="loader-container1">
        <div className="spinner1"></div>
        <p>Loading...</p>
    </div>
);
const EditManageAdvanceForm = () => {
    const { id } = useParams();
    const [RptMgr, setRptMngr] = useState('');

    const formatDateTime = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();

        // Get hours and minutes
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12; // Convert to 12-hour format
        hours = hours ? String(hours).padStart(2, '0') : '12'; // Handle 0 as 12

        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    };
    const [EmpCode, setEmpCode] = useState('');
    const [items, setItems] = useState([]);
    const [purposes, setPurposes] = useState([]);
    const [showCustomInput, setShowCustomInput] = useState(false);
    const [loading, setLoading] = useState(true);
    // State to hold errors
    const [errors, setErrors] = useState({
        rpt_mgr_status: '', // Initial errors can go here (empty or predefined)
    });
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        purpose: '',
        mode_of_travel: '',
        travel_advance: '',
        travel_advance_amount: '',
        rpt_mgr_status: '',
        days: '',
        city: '',
        hotel_tickets: '',
        travel_tickets: '',
        manager_remarks: '',
        manager_approved_amount: '',
        manager_approved_date: '',
        created_on: '',
        bank_acnum: '',
        bank_name: '',
        advance_from_date: '',
        ifsc_code: '',
    });
    const [responseMessage, setResponseMessage] = useState('');
    const [isApproved, setIsApproved] = useState(false);
    const navigate = useNavigate();

    const validateFormData = () => {
        const { comp_name, emp_code, grade } = formData;
        if (!comp_name | !emp_code | !grade) {
            toast.error('All fields are required');
            return false;
        }
        return true;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value || '' // Ensure it's never undefined
        }));
        if (name === 'manager_approved_amount') {
            const travelAdvance = parseFloat(formData.travel_advance_amount) || 0;
            const approvedAmount = parseFloat(value) || 0;
            // if (formData.manager_approved_amount === 0){
            //     setError('Should not be 0');
            // }

            // if (approvedAmount > travelAdvance) {
            //     console.log("check", value);
            //     setError('Manager Approved Amount must be less than or equal to Travel Advance Requisitioned.');
            // } else {
            //     setError(''); // Clear the error if both conditions are met
            // }
        }
    };

    const handleBackClick = () => {
        navigate("/manage_advance");
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        // Validation before submission
        let formIsValid = true;
        let newErrors = {};

        // If Reporting Manager Status is Pending, show error
        if (formData.rpt_mgr_status === 'Pending') {
            formIsValid = false;
            newErrors.rpt_mgr_status = 'Please approve the status before submitting.';
        }

        if (!formIsValid) {
            setErrors(newErrors); // Update errors state if form is invalid
            return;
        }

        if (formData.rpt_mgr_status != 'Rejected' && formData.manager_approved_amount == 0) {
            formIsValid = false;
            alert('Please Add Amount.');
            return;
        }

        if (formData.manager_approved_amount > formData.travel_advance_amount) {
            alert("Reporting Manager Approved amount is more than advance amount");
            return;
        }


        if (!validateFormData()) return;

        const travelAdvance = parseFloat(formData.travel_advance_amount) || 0;
        // if (parseFloat(formData.manager_approved_amount) > travelAdvance) {
        //     setError('Manager Approved Amount must be less than or equal to Travel Advance Requisitioned.');
        //     return; // Prevent submission
        // }
        const approvedAmount = parseFloat(formData.manager_approved_amount) || 0;

        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key] !== null && formData[key] !== '') {
                formDataToSubmit.append(key, formData[key]);
            }
        });
        const dataToSubmit = {
            ...formData
        };
        try {
            const token = localStorage.getItem('authToken');
            console.log("check tokens", token);
            const response = await fetch(`${API_BASE_URL}updateAdvanceForm/${id}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSubmit),
            });

            const result = await response.json();
            console.log("advanceformdata", result.data);
            if (result.status) {
                toast.success('Travel Advance Form successfully added');
                setFormData({
                    comp_name: '',
                    emp_code: ''
                });
                navigate('/manage_advance');
            } else {
                toast.error(result.message || 'An error occurred while adding the travel advance form.');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            toast.error('Failed to submit form');
        }
    };

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("token1", token);
                const response = await fetch(`${API_BASE_URL}getadvance?id=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                console.log("Profile data1:", result);

                if (result.status) {
                    setEmpCode(result.advance.emp_code || '');
                    const report_mngr = result.advance.report_mngr || '';
                    const rpt_mgr_status = result.advance.rpt_mgr_status || '';
                    setFormData({
                        comp_name: result.advance.comp_name || '',
                        emp_code: result.advance.emp_code || '',
                        trans_code: result.advance.trans_code || '',
                        dept_name: result.advance.dept_name || '',
                        designation_name: result.advance.designation_name || '',
                        purpose: result.advance.purpose || '',
                        customPurpose: result.advance.customPurpose || '',
                        mode_of_travel: result.advance.mode_of_travel || '',
                        travel_advance_amount: result.advance.travel_advance_amount || '',
                        account_status: result.advance.account_status || '',
                        account_remarks: result.advance.account_remarks || '',
                        days: result.advance.days || '',
                        city: result.advance.city || '',
                        travel_advance: result.advance.travel_advance || '',
                        bank_details: result.advance.bank_details || '',
                        guesthouse: result.advance.guesthouse || '',
                        grade: result.advance.grade || '',
                        mobile: result.advance.mobile || '',
                        rpt_mgr_status: rpt_mgr_status || '',
                        report_mngr: report_mngr,
                        manager_remarks: result.advance.manager_remarks || '',
                        manager_approved_amount: result.advance.manager_approved_amount || '',
                        manager_approved_date: result.advance.manager_approved_date || '',
                        created_on: result.advance.created_on || '',
                        hotel_tickets: result.advance.hotel_tickets || '',
                        travel_tickets: result.advance.travel_tickets || '',
                        bank_acnum: result.advance.bank_acnum || '',
                        bank_name: result.advance.bank_name || '',
                        ifsc_code: result.advance.ifsc_code || '',
                        advance_from_date: result.advance.advance_from_date || '',
                        advance_to_date: result.advance.advance_to_date || '',
                    });
                    setIsApproved(rpt_mgr_status === 'Approved');
                    // fetchReportingData(report_mngr);
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);


    useEffect(() => {
        const fetchCitiesData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("token1", token);
                const response = await fetch(`${API_BASE_URL}cities`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                console.log("get all cities data:", result);

                if (result.status) {
                    setItems(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchCitiesData();
    }, []);

    const currentDateTime = formatDateTime(new Date());

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const token = localStorage.getItem('authToken');

                if (!token) return;

                const response = await fetch(`${API_BASE_URL}purposes`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    setPurposes(result.data); // Set the fetched purposes
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                //setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, [navigate]);

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">

                <Header />
                <Sidebar />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Tour/Travel Reporting Manager Advance Approval Form {formData.trans_code && `(${formData.trans_code})`}</h4>
                                </div>
                                <div className="col-sm-4">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Tour/Travel Reporting Manager Advance Approval Form </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="col-lg-12">
                        <div className="card" style={{ borderTop: '3px solid #00c0ef' }}>
                            <div className="box box-info">


                                <div className="card-body">
                                    {loading ? (
                                        <Loader /> // Show loader if loading is true
                                    ) : (
                                        <>
                                            <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                                <div className="box-body">
                                                    <div className="row">

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Employee No/Consultant
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData.emp_code || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Department&Designation"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Department&Designation"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>



                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Employee Band as per Category  </label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee Band as per Category"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        {!formData.customPurpose && (
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label style={{ fontSize: '12px' }} htmlFor="purpose">
                                                                        Purpose
                                                                    </label>
                                                                    {loading ? (
                                                                        <p>Loading purposes...</p>
                                                                    ) : error ? (
                                                                        <p>{error}</p>
                                                                    ) : (
                                                                        <select
                                                                            name="purpose"
                                                                            id="purpose"
                                                                            value={formData.purpose}
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                // Show custom input if "Others" is selected
                                                                                setShowCustomInput(e.target.value === "Others");
                                                                            }}
                                                                            className="form-control input-font"
                                                                            required
                                                                            readOnly
                                                                        >
                                                                            <option value="">Select a purpose</option>
                                                                            {purposes.map(item => (
                                                                                <option key={item.id} value={item.purpose}>
                                                                                    {item.purpose}
                                                                                </option>
                                                                            ))}
                                                                            <option value="Others">Others</option>
                                                                        </select>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Show Specify Purpose input only if purpose is "Others" or customPurpose is set */}
                                                        {(formData.purpose === 'Others' || formData.customPurpose) && (
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label style={{ fontSize: '12px' }} htmlFor="customPurpose">
                                                                        Specify Purpose
                                                                    </label>
                                                                    <textarea
                                                                        name="customPurpose"
                                                                        id="customPurpose"
                                                                        placeholder="Specify your purpose"
                                                                        value={formData.customPurpose}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        readOnly
                                                                        rows={1} // Adjust the number of rows as needed
                                                                    // Optional: restrict to 12 characters
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="row">

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="mode_of_travel">Mode of Travel

                                                                </label>
                                                                <select
                                                                    name="mode_of_travel"
                                                                    id="mode_of_travel"
                                                                    value={formData.mode_of_travel || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readOnly={true}
                                                                    disabled
                                                                >
                                                                    <option value={formData.mode_of_travel}>{formData.mode_of_travel}</option>

                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">
                                                                    Travel Advance requisitioned
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="travel_advance_amount"
                                                                    id="name"
                                                                    value={formData.travel_advance_amount ? `₹ ${formData.travel_advance_amount}` : ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Travel Advance requisitioned"
                                                                    readOnly={true}
                                                                    disabled
                                                                    style={{
                                                                        fontSize: '20px',       // Increase the font size
                                                                        color: 'green',         // Set text color to green
                                                                        fontWeight: 'bold',     // Optional: Make the text bold
                                                                        textAlign: 'left'     // Optional: Center the text inside the input field
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="travelAdvance">Has earlier travel advance settled </label>
                                                                <select
                                                                    name="travel_advance"
                                                                    id="travelAdvance"
                                                                    value={formData.travel_advance || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readOnly={true}
                                                                    disabled
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="yes">Yes</option>
                                                                    <option value="no">No</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="days">Days of travel

                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    name="days"
                                                                    id="days"
                                                                    value={formData.days || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="1,1.5,2,2.5,etc"
                                                                    required
                                                                    min="1" // Prevents entering 0 or negative numbers
                                                                    step="0.1"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="city">Place to travel

                                                                </label>
                                                                <select
                                                                    name="city"
                                                                    id="city"
                                                                    value={formData.city || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readOnly={true}
                                                                    disabled
                                                                >
                                                                    <option value="">Select a city</option>
                                                                    {items.map((city) => (
                                                                        <option key={city.id} value={city.city_name}>
                                                                            {city.city_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-2'>
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="guesthouse">Select City Guest-House
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <select
                                                                    required
                                                                    name="guesthouse"
                                                                    id="guesthouse"
                                                                    value={formData.guesthouse}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    disabled
                                                                >
                                                                    <option value="">Select a Guest-House</option>
                                                                    <option value="Hyderabad">Hyderabad</option>
                                                                    <option value="Vishakapatnam">Vishakapatnam</option>
                                                                    <option value="Rajuhmundry">Rajuhmundry</option>
                                                                    <option value="Gurgaon">Gurgaon</option>
                                                                    <option value="Gulbarga">Gulbarga</option>
                                                                    <option value="no">No</option>
                                                                    
                                                                </select>
                                                            </div>
                                                        </div>



                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Reporting To
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Days of travel"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Days of travel"
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="hotel_tickets">Hotel/Tickets Booked by

                                                                </label>
                                                                <select
                                                                    name="hotel_tickets"
                                                                    id="hotel_tickets"
                                                                    value={formData.hotel_tickets || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readOnly={true}
                                                                    disabled
                                                                >

                                                                    <option value="Self">Self</option>
                                                                    <option value="TravelDesk">Travel Desk</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row"><div className="col-md-4">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: '12px' }} htmlFor="travel_tickets">Travel/Tickets Booked by

                                                            </label>
                                                            <select
                                                                name="travel_tickets"
                                                                id="travel_tickets"
                                                                value={formData.travel_tickets || ''}
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                readOnly={true}
                                                                disabled
                                                            >

                                                                <option value="Self">Self</option>
                                                                <option value="TravelDesk">Travel Desk</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="advance_from_date">
                                                                    Advance From Date <span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    required
                                                                    id="advance_from_date"
                                                                    name="advance_from_date"
                                                                    value={formData.advance_from_date}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    disabled
                                                                  
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='col-md-4'>
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="advance_to_date">
                                                                    Advance To Date <span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    required
                                                                    id="advance_to_date"
                                                                    name="advance_to_date"
                                                                    value={formData.advance_to_date}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    disabled
                                                                  
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="name">Bank Ac Num </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="name"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Department&Designation"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="bank_name">Bank Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee Band as per Category"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="ifsc_code">IFSC Code </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee Band as per Category"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="rpt_mgr_status">Reporting Manager Status
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <select
                                                                    name="rpt_mgr_status"
                                                                    id="rpt_mgr_status"
                                                                    value={formData.rpt_mgr_status || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control  custom-select"
                                                                    required
                                                                >

                                                                    <option value="Pending">Pending</option>
                                                                    <option value="Approved">Approved</option>
                                                                    <option value="Rejected">Rejected</option>
                                                                </select>
                                                                {errors.rpt_mgr_status && (
                                                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                        {errors.rpt_mgr_status}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* Conditionally render the Reporting Manager Approved Amount field */}
                                                        {formData.rpt_mgr_status !== 'Rejected' && (
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label style={{ fontSize: '12px' }} htmlFor="manager_approved_amount">
                                                                        Reporting Manager Approved Amount
                                                                        <span style={{ color: 'red' }}>*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="manager_approved_amount"
                                                                        id="manager_approved_amount"
                                                                        value={formData.manager_approved_amount !== '' ? Math.floor(formData.manager_approved_amount) : ''}
                                                                        onChange={(e) => {
                                                                            // Ensure the input only accepts digits and at most one decimal point
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                                handleChange(e);
                                                                            }
                                                                        }}
                                                                        className="form-control input-font"
                                                                        required
                                                                        min="1"   // Disallow zero and negative values
                                                                        step="1"    // Allows decimals, but restricts values to be above 0
                                                                    />
                                                                </div>
                                                                {error && <p style={{ color: 'red' }}>{error}</p>} {/* Display error message */}
                                                            </div>
                                                        )}


                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label style={{ fontSize: '12px' }} htmlFor="remarks">Reporting Manager Remarks
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                </label>

                                                                <textarea name="manager_remarks"
                                                                    required
                                                                    id="remarks"
                                                                    value={formData.manager_remarks || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control "
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="account_status">Finance Status
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <select
                                                                    name="account_status"
                                                                    id="account_status"
                                                                    value={formData.audit_status}
                                                                    onChange={(e) => handleChange('account_status', e)}
                                                                    required
                                                                    className="form-control input-font custom-select"
                                                                    disabled
                                                                >

                                                                    <option value="Pending">Pending</option>
                                                                    <option value="Approved">Approved</option>
                                                                    <option value="Rejected">Rejected</option>
                                                                </select>
                                                                {errors.rpt_mgr_status && (
                                                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                        {errors.rpt_mgr_status}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="rpt_mgr_status">Finance Remarks
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <textarea
                                                                    id="account_remarks"
                                                                    name="account_remarks"
                                                                    value={formData.account_remarks}
                                                                    onChange={(e) => handleChange('account_remarks', e)}
                                                                    className="form-control"

                                                                    required
                                                                    disabled
                                                                ></textarea>
                                                                {errors.rpt_mgr_status && (
                                                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                        {errors.rpt_mgr_status}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div></div> */}
                                                </div>

                                                <div className="box-footer" style={{ textAlign: 'center' }}>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-success pull-right"
                                                        disabled={isApproved}
                                                    >
                                                        Submit
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary ml-3"
                                                        onClick={handleBackClick} // Handle redirect
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                                <br />

                                            </form>
                                            <div className="col-sm-12 row" style={{ width: '100%' }}>
                                                <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                    <b>Prepared by </b>
                                                    <p> {formData.emp_code} ({formData.comp_name})<br /> Date
                                                        : {formData.created_on}
                                                    </p>
                                                </div>




                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />

                <aside className="control-sidebar control-sidebar-dark">
                </aside>

            </div>

            {/* Toast Container */}
            <ToastContainer />
        </div>
    );
};

export default EditManageAdvanceForm;
